import actionTypes from "../actions/action-types";
import {sendRequest, postData} from '../utils/request';
import http_build_query from "locutus/php/url/http_build_query";
import { push } from 'connected-react-router';
import {setFormValues,setPristineValues,setInitialValues,setFieldValue,setEditorConfig} from './editors';
import {setSelectorGridState} from './SelectorGrids';
import {setSelectorImageState} from './SelectorImages';
import {setBoxState} from './Boxes';
import {createMenu,toggleMenu,activeMenu,keepOpenedMenu} from './menu';
import {setPacePercent,endPace,startPace} from './pace';
import Cookies from 'universal-cookie';
import moment from 'moment';
import parse_url from "locutus/php/url/parse_url";

const getPath = () => {
    let path = parse_url(window.location.href).path || "//";
    if (path.endsWith("/")) {
        return path.slice(0, -1);
    }
    return path;
}

const getHost = () => {
    return parse_url(window.location.href).host;
}

const cookies = new Cookies();
// TODO ezt majd ha mindenhol kikerült élesre az új context akkor el kell tüntetni
["till_id", "pos_id", "client_id", "location_section_id"].forEach((key) => {
    const v = cookies.get(key);
    if (v !== undefined) {
        const domain = "." + getHost();
        cookies.remove(key, { path: getPath(), expires: moment().add(1, 'years').toDate() });
        cookies.set(key, v, { path: getPath(), expires: moment().add(1, 'years').toDate(), domain });
    }
});

export const showModal = (props) => {
    return {type: actionTypes.SHOW_MODAL, properties: {state: "on", ...props}}
};
export const closeModal = (props) => {
    return {type: actionTypes.CLOSE_MODAL, properties: {state: "off", ...props}};
};
export const toggleSidebar = () => {
    return {type: actionTypes.TOGGLE_SIDEBAR};
};
export const setUser = (data) => {
    return {type: actionTypes.SET_USER, data};
};

export const setContent = (content, props = {}) => {
    return push('?' + http_build_query({option: content, ...props}));
    //return {type: actionTypes.SET_CONTENT, content, props};
};


export function loadMainMenu() {
    return async function (dispatch) {
        dispatch(createMenu([]));
        const data = await sendRequest({option: 'menu', filter: [{field: "token", value: "admin"}]});
        dispatch(createMenu(data.items));
    }
};

export function loginUser({detach = true} = {}) {
    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            try {
                detach && dispatch(setUser({id: null}));
                const data = await sendRequest({option: 'currentuser', view: 'admin'});
                if (data.id !== null) {
                    data.dispatch = true;
                    loadContext()(dispatch);
                    dispatch(setUser(data));
                    resolve(data);
                } else {
                    loadContext()(dispatch);
                    dispatch(setUser({id: null, dispatch: true}));
                    resolve(data);
                }
            } catch (e) {
                reject(e);
            }
        });
    }
};

export function logoutUser(cb) {
    return async function (dispatch) {
        const data = await postData({action: "currentuser.logoutuser"});
        if (data.success) {
            await loadValue("client_id", null, true)(dispatch);
            dispatch(setUser({id: null, dispatch: true}));
            if (cb instanceof Function) cb();
        }
    }
};

const setContext = (data) => {
    return {type: actionTypes.SET_CONTEXT, data};
};

export const loadContext = () => {
    return async function (dispatch) {
        try {
            const data = await sendRequest({option: 'Context'}, {showError: false});
            data.dispatch = true;
            dispatch(setContext(data));
        } catch (e) {
            dispatch(setContext({dispatch: true}));
        }
    }
};

const loadValue = (key, value, canBeEmpty = false) => {
    return async function (dispatch) {
        if (!canBeEmpty && !value) {
            await loadContext()(dispatch);
            return;
        }
        await postData({
            action: "Context.update",
            data: {
                [key]: value ?? null
            }
        }, {}, {
            url: getPath()
        });
        await loadContext()(dispatch);
    }
}

export const setPos = (pos_id) => {
    return loadValue("pos_id", pos_id);
};

export const setTill = (till_id) => {
    return loadValue("till_id", till_id, true);
};

export const setLocationSection = (location_section_id) => {
    return loadValue("location_section_id", location_section_id, true);
};

export const setClient = (partner_id) => {
    return loadValue("client_id", partner_id);
};

function reduxStoreChanged(newState) {
    return {type: actionTypes.REDUX_STORE_CHANGED, payload: newState}
};

export {
    setFormValues,
    setPristineValues,
    setInitialValues,
    setFieldValue,
    setEditorConfig,
    setSelectorGridState,
    setSelectorImageState,
    setBoxState,
    createMenu,
    toggleMenu,
    activeMenu,
    keepOpenedMenu,
    setPacePercent,
    endPace,
    startPace,
    reduxStoreChanged
};
